import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import { Users, Calendar, CalendarCheck } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const FetSightSeeingCard = ({ pkg }) => {
  const [imgLoaded, setImgLoaded] = useState(false);
  const navigate = useNavigate();
  
  if (!pkg) return null; // 💥 Avoid null/undefined crash
    const prices = pkg.vehiclePrices ? Object.values(pkg.vehiclePrices).map(Number) : [];
    const minPrice = prices.length > 0 ? Math.min(...prices) : null;
  const mainImage =
    Array.isArray(pkg.images) && pkg.images.length > 0 ? pkg.images[0] : '';

  return (
    <div
      className="room-card-wrapper"
      style={{
        flex: '1 1 250px',
        maxWidth: '290px',
        minWidth: '230px',
        marginTop: '5px',
      }}
    >
      <Card
        className="shadow-sm rounded overflow-hidden room-card h-100"
        onClick={() => navigate(`/site-seeing-details/${pkg.id}`)}
        style={{ cursor: 'pointer' }}
      >
        <div className="position-relative">
          {!imgLoaded && (
            <div
              className="placeholder-glow"
              style={{ height: 140, backgroundColor: '#e9ecef' }}
            />
          )}
          {mainImage && (
            <Card.Img
              variant="top"
              src={mainImage}
              onLoad={() => setImgLoaded(true)}
              style={{
                height: 140,
                objectFit: 'cover',
                display: imgLoaded ? 'block' : 'none',
              }}
            />
          )}
        </div>

        <Card.Body className="py-2 px-3">
          {!imgLoaded ? (
            <>
              <Skeleton height={18} width={160} />
              <Skeleton height={18} width={100} />
            </>
          ) : (
            <>
              {/* Title */}
              <div
                className="mb-1"
                style={{ fontSize: '0.95rem', color: '#0f172a' }}
              >
                <b>{pkg.name}</b>
              </div>

              {/* Bottom Row: Price + Guests + Days */}
              <div className="d-flex justify-content-between align-items-center">
                <div
                  className="fw-semibold"
                  style={{ fontSize: '0.9rem', color: '#54b435' }}
                >
                    {minPrice !== null
                                    ? <>₹{minPrice.toLocaleString('en-IN')} <small className="text-muted ms-1">/ Onwards</small></>
                                    : <small className="text-muted">Price on request</small>
                                }
                </div>

                {/* <div className="d-flex text-muted" style={{ fontSize: '0.8rem' }}>
                  <div className="d-flex align-items-center me-3">
                    <Users size={14} className="me-1" />
                    {pkg.guestCount}
                  </div>
                  <div className="d-flex align-items-center">
                    <CalendarCheck size={14} className="me-1" />
                    {pkg.days}
                  </div>
                </div> */}
              </div>
            </>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default FetSightSeeingCard;
